import { render, staticRenderFns } from "./OsInfo.vue?vue&type=template&id=4d8066ee&scoped=true"
import script from "./OsInfo.vue?vue&type=script&lang=js"
export * from "./OsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8066ee",
  null
  
)

export default component.exports